import { useEffect } from 'react';

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const useSEO = ({ title, description, ogTitle, ogDescription, ogImage, ogType, canonical, author, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('name', 'twitter:description', description);
    }
    if (ogTitle) {
      setMeta('property', 'og:title', ogTitle);
      setMeta('name', 'twitter:title', ogTitle);
    }
    if (ogDescription) setMeta('property', 'og:description', ogDescription);
    if (ogImage) {
      setMeta('property', 'og:image', ogImage);
      setMeta('name', 'twitter:image', ogImage);
    }
    if (ogType) setMeta('property', 'og:type', ogType);
    if (author) setMeta('property', 'article:author', author);
    setMeta('property', 'og:url', window.location.href);
    if (canonical) setLink('canonical', canonical);

    // JSON-LD structured data
    if (jsonLd) {
      let script = document.getElementById('page-jsonld');
      if (!script) {
        script = document.createElement('script');
        script.id = 'page-jsonld';
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }

    return () => {
      const script = document.getElementById('page-jsonld');
      if (script) script.remove();
    };
  }, [title, description, ogTitle, ogDescription, ogImage, ogType, canonical, author, jsonLd]);
};
